import { ReactNode } from 'react'

import Box from '~/core/Box'

interface ShippmentInfoType {
    title: string
    children: ReactNode
}

export default function ShipmentInfo(props: ShippmentInfoType) {
    const { title, children } = props

    return (
        <>
            <strong>{title}</strong>
            <Box>{children}</Box>
        </>
    )
}
